import moment from 'moment'

export const tabelasRelatoriosOperadorMethods = {
  calculaValoresPrincipaisTabelasLigacoes(objetoLigacoes) {
    let atendidas
    let naoAtendidas
    let total
    let porcentagemAtendidas
    let porcentagemNaoAtendidas
    let tmc
    let tma
    let tme

    if (typeof objetoLigacoes.atendidas !== 'undefined') {
      atendidas = Number(objetoLigacoes.atendidas)
    } else {
      atendidas = 0
    }

    if (typeof objetoLigacoes.naoAtendidas !== 'undefined') {
      naoAtendidas = Number(objetoLigacoes.naoAtendidas)
    } else {
      naoAtendidas = 0
    }

    total = atendidas + naoAtendidas

    if (total === 0) {
      porcentagemAtendidas = 0
      porcentagemNaoAtendidas = 0
    } else {
      porcentagemAtendidas = (atendidas / total) * 100
      porcentagemNaoAtendidas = (naoAtendidas / total) * 100
    }

    if (typeof objetoLigacoes.mediaTempoDeChamada !== 'undefined') {
      tmc = objetoLigacoes.mediaTempoDeChamada
    } else {
      tmc = '00:00:00'
    }

    if (typeof objetoLigacoes.mediaTempoDeAtendimento !== 'undefined') {
      tma = objetoLigacoes.mediaTempoDeAtendimento
    } else {
      tma = '00:00:00'
    }

    if (typeof objetoLigacoes.mediaEspera !== 'undefined') {
      tme = objetoLigacoes.mediaEspera
    } else {
      tme = '00:00:00'
    }

    return { atendidas, naoAtendidas, total, porcentagemAtendidas, porcentagemNaoAtendidas, tma, tmc, tme }
  },

  preencheTabelaLigacoesPorHora(arrayLigacoes) {
    let itemsHora = []
    arrayLigacoes.forEach(dado => {
      let {
        atendidas,
        naoAtendidas,
        total,
        porcentagemAtendidas,
        porcentagemNaoAtendidas,
        tma,
        tmc,
        tme,
      } = this.calculaValoresPrincipaisTabelasLigacoes(dado)

      itemsHora.push({
        data: dado.data,
        hora: dado.hora,
        total,
        atendidas: `${atendidas} (${porcentagemAtendidas.toFixed(0)}%)`,
        naoAtendidas: `${naoAtendidas} (${porcentagemNaoAtendidas.toFixed(0)}%)`,
        tmc,
        tma,
        tme,
      })
    })
    return itemsHora
  },

  preencheTabelaLigacoesPorDia(objetoLigacoes) {
    let itemsDia = []
    let keys = Object.keys(objetoLigacoes)
    let values = Object.values(objetoLigacoes)

    const newKeys = keys.map(data => moment(data, 'DD-MM-YYYY').format('DD/MM/YYYY'))

    for (let i = 0; i < keys.length; i++) {
      let {
        atendidas,
        naoAtendidas,
        total,
        porcentagemAtendidas,
        porcentagemNaoAtendidas,
        tma,
        tmc,
        tme,
      } = this.calculaValoresPrincipaisTabelasLigacoes(values[i])
      itemsDia.push({
        data: newKeys[i],
        total,
        atendidas: `${atendidas} (${porcentagemAtendidas.toFixed(0)}%)`,
        naoAtendidas: `${naoAtendidas} (${porcentagemNaoAtendidas.toFixed(0)}%)`,
        tmc,
        tma,
        tme,
      })
    }
    return itemsDia
  },
}
